import React from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  withStyles,
} from '@material-ui/core';

import {
  describeUserLimitForRider,
  describeUserLimitProgressForRider,
  userLimitKey,
} from 'common/types/ServiceUserLimit';

const styles = {
  group: {marginBottom: '16px'},
  limit: {marginBottom: '4px'},
  progress: {marginBottom: 0, fontSize: '0.875rem'},
};

const EligibilityLimitsDialog = ({userLimits, usageByKey, open, handleClose, classes}) => (
  <Dialog
    open={open}
    onClose={handleClose}
    maxWidth="sm"
    fullWidth
    data-id="eligibility-limits-dialog"
  >
    <DialogTitle>Booking Limits</DialogTitle>
    <DialogContent>
      {userLimits.map((userLimit) => {
        const usage = usageByKey[userLimitKey(userLimit)];
        return (
          <div key={userLimit.uuid} className={classes.group}>
            <DialogContentText className={classes.limit}>
              {describeUserLimitForRider(userLimit)}
            </DialogContentText>
            {usage !== undefined &&
              <DialogContentText
                className={classes.progress}
                data-id="eligibility-limits-progress"
              >
                {describeUserLimitProgressForRider(userLimit, usage)}
              </DialogContentText>}
          </div>
        );
      })}
    </DialogContent>
    <DialogActions>
      <Button onClick={handleClose} color="primary" data-id="eligibility-limits-ok">
        OK
      </Button>
    </DialogActions>
  </Dialog>
);

EligibilityLimitsDialog.propTypes = {
  userLimits: PropTypes.array.isRequired,
  usageByKey: PropTypes.object,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  classes: PropTypes.object.isRequired,
};

EligibilityLimitsDialog.defaultProps = {
  usageByKey: {},
};

export default withStyles(styles)(EligibilityLimitsDialog);



// WEBPACK FOOTER //
// ./src/ondemand/components/EligibilityLimitsAlert/EligibilityLimitsDialog.js